"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Check_exports = {};
__export(Check_exports, {
  default: () => Check_default
});
module.exports = __toCommonJS(Check_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M22.319 4.43101L8.5 18.249C8.40709 18.3423 8.29668 18.4163 8.17509 18.4668C8.05351 18.5173 7.92315 18.5433 7.7915 18.5433C7.65985 18.5433 7.52949 18.5173 7.4079 18.4668C7.28632 18.4163 7.17591 18.3423 7.083 18.249L1.739 12.9C1.64609 12.8067 1.53568 12.7327 1.41409 12.6822C1.29251 12.6317 1.16215 12.6057 1.0305 12.6057C0.898845 12.6057 0.768487 12.6317 0.646905 12.6822C0.525322 12.7327 0.414909 12.8067 0.321999 12.9C0.228722 12.9929 0.15471 13.1033 0.104208 13.2249C0.0537066 13.3465 0.02771 13.4769 0.02771 13.6085C0.02771 13.7402 0.0537066 13.8705 0.104208 13.9921C0.15471 14.1137 0.228722 14.2241 0.321999 14.317L5.668 19.662C6.23195 20.2249 6.9962 20.5411 7.793 20.5411C8.5898 20.5411 9.35405 20.2249 9.918 19.662L23.736 5.84701C23.8291 5.75412 23.903 5.64377 23.9534 5.52228C24.0038 5.40079 24.0298 5.27054 24.0298 5.13901C24.0298 5.00747 24.0038 4.87723 23.9534 4.75574C23.903 4.63425 23.8291 4.5239 23.736 4.43101C23.6431 4.33773 23.5327 4.26372 23.4111 4.21322C23.2895 4.16272 23.1592 4.13672 23.0275 4.13672C22.8958 4.13672 22.7655 4.16272 22.6439 4.21322C22.5223 4.26372 22.4119 4.33773 22.319 4.43101Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgCheck = SvgIcon;
var Check_default = SvgCheck;
//# sourceMappingURL=Check.js.map